
import { useEffect } from 'react';
import { AppRoutes } from "./router";
import { BrowserRouter, useLocation } from "react-router-dom";
import Header from "./components/feature/Header";
import Footer from "./components/feature/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <Header />
      <main className="pt-[90px]">
        <AppRoutes />
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
